import { styled } from '@mui/material/styles';
import { useExportMode, useSwimlaneRootProps } from '@/common/components/ui/swimlane/context';
import { GRID_GAP } from '../constants';
import { getRowHeaderBlockWidth } from '../geometry';
import { getColumnHeaderBlockHeight } from '../layoutMetrics';

// These styles allow the corner to mask the CSS grid gap
// This prevents the Card on hover shadow from bleeding past headers
const StyledDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isHeadersSticky' && prop !== 'backgroundColor',
})<{
  isHeadersSticky: boolean;
  backgroundColor: string;
}>(({ isHeadersSticky, backgroundColor }) => ({
  backgroundColor,
  position: isHeadersSticky ? 'sticky' : 'relative',
  gridArea: 'erase',
  zIndex: '11',
  left: `-${GRID_GAP.label}`,
  top: 0,
  boxSizing: 'content-box',
}));

export function TopLeftCorner() {
  const {
    rowHeaderOrientation,
    rowHeadersWidth,
    rowHeaders,
    isHeadersSticky,
    backgroundColor,
    columnAxisLabelText,
    rowAxisLabelText,
    isAddRowHeaderButtonVisible,
  } = useSwimlaneRootProps();
  const { isExporting } = useExportMode();

  const hasRowHeaders = rowHeaders.length > 0;
  const hasAxisLabelColumn = typeof columnAxisLabelText === 'string';
  const hasAxisLabelRow = typeof rowAxisLabelText === 'string';

  const hasGroupHeaders = rowHeaders.some((h) => 'isGroupHeader' in h && h.isGroupHeader === true);
  const height = getColumnHeaderBlockHeight(hasAxisLabelColumn);
  const totalWidth = `${
    getRowHeaderBlockWidth({
      hasRowHeaders,
      hasGroupHeaders,
      hasAxisLabelRow,
      isAddRowHeaderButtonVisible,
      rowHeaderOrientation,
      rowHeadersWidth,
    }) + GRID_GAP.value
  }px`;

  return (
    <StyledDiv
      backgroundColor={backgroundColor}
      isHeadersSticky={!!isHeadersSticky && !isExporting}
      style={{
        width: totalWidth,
        height,
      }}
    />
  );
}
